import { STATES } from '../../constants';
import { isFeatureEnabled } from '@updater-core/lib/optimizely';
import { makePageNewBackgroundColor } from '../steps/forward-mail/uds-utils';
import { actions } from '../../state';

export function VerifyConfig($stateProvider) {
  'ngInject';
  $stateProvider
    .state(STATES.VERIFY, {
      ...getVerifyState(),
      title: 'Verify Your Address',
    })
    .state(STATES.MOVES_VERIFY, getVerifyState())
    .state(STATES.STEP_FORWARD_MAIL_VERIFY, getVerifyState({ fym: true }))
    .state(STATES.STEP_UPDATE_ACCOUNTS_VERIFY, getVerifyState());

  function getVerifyState({ fym } = {}) {
    return {
      url: '/verify',
      views: {
        '@': {
          template: '<upd-verify></upd-verify>',
        },
      },
      scrollTop: true,
      data: {
        permissions: 'signedIn',
      },
      analytics: {
        page: 'Verify',
      },
      resolve: {
        redirect: (updStore, $state) => {
          'ngInject';
          return isFeatureEnabled('fym_reskin').then((enabled) => {
            if (
              enabled &&
              fym &&
              $state.next.name === STATES.STEP_FORWARD_MAIL_VERIFY
            ) {
              updStore.dispatch(
                actions.router.stateGo(`${$state.next.name}.phone`)
              );
            }
          });
        },
        origin: ($state) => {
          'ngInject';
          const nextState = $state.get($state.next.name).name;
          const parentState = nextState.split('.verify')[0];
          const { afterVerifyState } = $state.get(parentState).data || {};

          return parentState === 'app'
            ? STATES.DASHBOARD
            : afterVerifyState || parentState;
        },
      },
      onEnter: function ($state, origin) {
        'ngInject';
        this.titleBar = ($state.get(origin) || {}).titleBar;
        isFeatureEnabled('fym_reskin').then((enabled) => {
          if (enabled && fym) {
            this._resetBreadcrumb = makePageNewBackgroundColor();
          }
        });
      },
      onExit: function () {
        this._resetBreadcrumb?.();
      },
    };
  }
}
